import {Collection} from '@ab/components';
import Model from '../models/main.m';

export default class extends Collection {
    static model = Model;
}
